import { sourceTexts, widgetTexts } from "app/pages/activation/components/RankWidget/texts";
import type { RTFormData } from "app/pages/activation/components/RankWidget/types";
import { RTWidgetNames } from "app/pages/activation/components/RankWidget/types";
import { DEVICES_TYPES_FOR_API } from "app/UtilitiesAndConstants/Constants/DevicesTypes";

export const KEYWORDS = "Keywords";
export const MAX_DOMAIN_LENGTH = 15;
export const MAX_COUNTRY_NAME_LENGTH = 15;
export const RT_PATH = "ranktracker.trend";
export const MAX_COMPETITORS = 10;
export const MIN_NAME_LENGTH = 2;
export const MAX_NAME_LENGTH = 50;

export const WEEK_DAYS = 6;
export const DESCRIPTION_ID = "creationDescription";
export const DEFAULT_RT_DURATION = "6d";
export const RT_KNOWLEDGE_BASE_URL = "https://support.similarweb.com/hc/en-us/articles/13004369569437-Rank-Tracker";

export const WORLD_WIDE_COUNTRY_ID = 999;

export const COMPETITORS_POPUP_WIDTH = 240;
export const COMPETITORS_POPUP_HEIGHT = 300;

export const SOURCES_POPUP_WIDTH = 170;
export const SOURCES_POPUP_HEIGHT = 145;

export const COUNTRIES_POPUP_WIDTH = 180;
export const COUNTRIES_POPUP_HEIGHT = 150;

export const ITEM_LOADER_HEIGHT = 76;
export const ITEM_LOADER_WIDTH = "100%";

export const COUNTRY_LOADER_HEIGHT = 20;
export const COUNTRY_LOADER_WIDTH = 120;

export const CAROUSEL_ITEM_MARGIN = 8;

export const NOT_FOUND_ERROR = "Campaign not found";

export const RANK_TRACKER_ID = "rankTracker-widget";

export const widgetItems = [
    {
        name: RTWidgetNames.FirstPosition,
        title: widgetTexts.firstPositionTitle,
        tooltip: widgetTexts.firstPositionTooltip,
        isInverted: false,
    },
    {
        name: RTWidgetNames.Top10,
        title: widgetTexts.top10Title,
        tooltip: widgetTexts.top10Tooltip,
        isInverted: false,
    },
    {
        name: RTWidgetNames.Dropped,
        title: widgetTexts.droppedTitle,
        tooltip: widgetTexts.droppedTooltip,
        isInverted: true,
    },
    {
        name: RTWidgetNames.MovedToTop3,
        title: widgetTexts.movedToTop3Title,
        tooltip: widgetTexts.movedToTop3Tooltip,
        isInverted: false,
    },
];

export const sources: { id: DEVICES_TYPES_FOR_API; text: string }[] = [
    {
        id: DEVICES_TYPES_FOR_API.COMBINED,
        text: sourceTexts[DEVICES_TYPES_FOR_API.COMBINED],
    },
    {
        id: DEVICES_TYPES_FOR_API.DESKTOP,
        text: sourceTexts[DEVICES_TYPES_FOR_API.DESKTOP],
    },
    {
        id: DEVICES_TYPES_FOR_API.MOBILE,
        text: sourceTexts[DEVICES_TYPES_FOR_API.MOBILE],
    },
];

export const sourceIcons = {
    [DEVICES_TYPES_FOR_API.DESKTOP]: "desktop",
    [DEVICES_TYPES_FOR_API.MOBILE]: "mobile-web",
};

export const modalStyles = {
    content: {
        padding: "0",
        border: "unset",
        width: "540px",
    },
};

export const initialFormData: RTFormData = {
    competitors: [],
    source: sources[0].id,
    country: 0,
    name: "",
    hasError: false,
};
